/**
 * ver 0.1
 * author jack
 */
import React from 'react'
import styled from 'styled-components';

class LoginLayer extends React.Component {
    fontSize = {
        'fontSize': '17px'
    }
    width = {
        'width': 'auto'
    }

    goLogin() {
        window.location.href = process.env.REACT_APP_SSO_URL
    }
    render() {
        return (
            <table id="lyrPop" className="bgdark"><tbody><tr>
                <td>
                    <div className="PopMain artPop needLog">
                        <strong style={this.fontSize}>
                            <font className="clrpont1" style={this.fontSize}>로그인이</font> 필요한 서비스 입니다.
                        </strong>
                        <div className="popDefBtns">
                            <CloseButton className="icon-X_close" onClick={this.props.onClose}></CloseButton>
                            <button className="confBtn" onClick={this.props.onClose}>닫기</button>
                            <button className="confBtn styPBg" onClick={this.goLogin} style={this.width}>로그인 하러가기</button>
                        </div>
                    </div>
                </td>
            </tr></tbody></table>
        )
    }
}

const CloseButton = styled.button`
    width: auto!important;
    border: 0!important;
    background: none!important;
`

export default LoginLayer



// WEBPACK FOOTER //
// ./src/common/container/layer/loginLayer.js